<template>
  <div class="user-profile mt-10 d-flex justify-center mx-auto">
    <v-row>
      <v-col cols="2">
        <img class="avatar" :src="user.avatarUrl" alt="">
      </v-col>
      <v-col cols="10">
        <div class="text-h4 text-center mb-10">
          {{user.lastName + ', ' + user.firstName}}
        </div>
        <v-row>
          <div class="information mx-10">
            <v-row class="align-center">
              <v-col cols="6"><div class="text-h6"><strong>E-mail</strong></div></v-col>
              <v-col><div>{{user.email}}</div></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="align-center">
              <v-col cols="6"><div class="text-h6"><strong>Tipo y N° de Documento</strong></div></v-col>
              <v-col><div>{{user.documentType.name + ' ' + user.documentId}}</div></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="align-center">
              <v-col cols="6"><div class="text-h6"><strong>País</strong></div></v-col>
              <v-col><div>{{user.country.name}}</div></v-col>
            </v-row>
            <v-row class="align-center">
              <v-col cols="6"><div class="text-h6"><strong>Provincia</strong></div></v-col>
              <v-col><div>{{user.province.name}}</div></v-col>
            </v-row>
            <v-row class="align-center">
              <v-col cols="6"><div class="text-h6"><strong>Ciudad</strong></div></v-col>
              <v-col><div>{{user.city.name}}</div></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="6"><div class="text-h6"><strong>Teléfonos</strong></div></v-col>
              <v-col>
                <v-row>{{user.phoneNumber}}</v-row>
                <v-row v-for="(phoneNumber, index) in user.additionalPhoneNumbers" :key="index">{{user.additionalPhoneNumbers[index]}}</v-row>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'UserProfile',
  data() {
    return {
      user: {}
    }
  },
  mounted() {
    
  }
}
</script>

<style>
.user-profile {
  width: 80%;
}

.avatar {
  border-radius: 50%;
  width: 100%;
}

.information {
  width: 100%;
}
</style>